export default "__VITE_ASSET__ab81255e__"